import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { EnvService } from 'src/app/service/env.service';
import { HospitalService } from '../../pages/_services';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit , OnDestroy{
  language: any;
  HospitalContacts;
  isLoading$: Observable<boolean>;
  private subscriptions: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/

  constructor(private HospitalService: HospitalService,public environment : EnvService,
    private translationService: TranslationService) { }

  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
   const sb = this.HospitalService.GetHospitalContacts().subscribe(res => {
      if (res.data != null && res.isSuccess)
      {
        this.HospitalContacts = res.data;
      }
    });
    this.subscriptions.push(sb);
    this.isLoading$ = this.HospitalService.isLoading$;
  }
  ngOnDestroy() {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }


}
